
 /* MEDIOS DE IMPUGNACION */
export const dataEstrados = [
 
  // DEL 08 DE JUNIO - BAJAR 12 DE JUNIO 14:00
 /*  {
    id: 1,
    numCedula: 2,
    folio: "01606-2026", 
    pdfMedio: "01606-2026-1.pdf", 
    pdfCedula: "01606-2026-2.pdf", 
  }, */

   
  // DEL 09 DE JUNIO - BAJAR 15 DE JUNIO 15:00
   {
    id: 2,
    numCedula: 1,
    folio: "01618-2026", 
    pdfMedio: "01618-2026-1.pdf", 
    pdfCedula: "01618-2026-2.pdf", 
  }, 
   
  // DEL 09 DE JUNIO - BAJAR 15 DE JUNIO 15:00
  {
    id: 3,
    numCedula: 1,
    folio: "01619-2026", 
    pdfMedio: "01619-2026-1.pdf", 
    pdfCedula: "01619-2026-2.pdf", 
  },
   // DEL 09 DE JUNIO - BAJAR 15 DE JUNIO 18:00
  {
    id: 4,
    numCedula: 1,
    folio: "01635-2026", 
    pdfMedio: "01635-2026-1.pdf", 
    pdfCedula: "01635-2026-2.pdf", 
  },
   // DEL 09 DE JUNIO - BAJAR 15 DE JUNIO 18:00
  {
    id: 5,
    numCedula: 1,
    folio: "01636-2026", 
    pdfMedio: "01636-2026-1.pdf", 
    pdfCedula: "01636-2026-2.pdf", 
  },
  // DEL 10 DE JUNIO - BAJAR 16 DE JUNIO 16:30
   {
    id: 6,
    numCedula: 1,
    folio: "01662-2026", 
    pdfMedio: "01662-2026-1.pdf", 
    pdfCedula: "01662-2026-2.pdf", 
  },
  // DEL 12 DE JUNIO - BAJAR 18 DE JUNIO 16:30
   {
    id: 7,
    numCedula: 1,
    folio: "01786-2026", 
    pdfMedio: "01786-2026-1.pdf", 
    pdfCedula: "01786-2026-2.pdf", 
  },
];

 /* AMONESTACIONES PUBLICAS */


export const dataAmonestaciones = [
/* SUBIDA: 28/05/26 BAJADA: 27/06/26 */
   {
     id: 1,
     numCedula: 25,
     pdfUrl: "25.pdf", 
   },
   
];

 /* ACUERDOS JUNTA GENERAL EJECUTIVA */
export const dataAcuerdosjge = [
  {
    id: 1,
    numCedula: 1,
    pdfUrl: "1jge.pdf", 
    nameDoc: " POR EL QUE SE APRUEBA LA SUSPENSIÓN DE PLAZOS Y TÉRMINOS DERIVADO DEL PRIMER PERIODO VACACIONAL CORRESPONDIENTE AL AÑO DOS MIL VEINTICINCO DEL PERSONAL DE ESTE INSTITUTO.",
  },
  {
   id: 2,
   numCedula: 2,
   pdfUrl: "2jge.pdf", 
   nameDoc: "POR EL QUE SE APRUEBA LA SUSPENSIÓN DE PLAZOS Y TÉRMINOS DERIVADO DEL PRIMER PERIODO VACACIONAL CORRESPONDIENTE AL AÑO DOS MIL VEINTICINCO DEL PERSONAL DE ESTE INSTITUTO.",
 },

];


export const dataDelegacionOE = [
  {
    id: 1,
    folio: "01-2025",
    pdfAcuerdo: "01-2025.pdf", 
  },
  {
    id: 1,
    folio: "02-2025",
    pdfAcuerdo: "02-2025.pdf", 
  },
  {
    id: 1,
    folio: "03-2025",
    pdfAcuerdo: "03-2025.pdf", 
  },
  {
    id: 1,
    folio: "04-2025",
    pdfAcuerdo: "04-2025.pdf", 
  },
  {
    id: 1,
    folio: "05-2025",
    pdfAcuerdo: "05-2025.pdf", 
  },
  {
    id: 1,
    folio: "01-2026",
    pdfAcuerdo: "01-2026.pdf", 
  },
  {
    id: 1,
    folio: "02-2026",
    pdfAcuerdo: "02-2026.pdf", 
  },
  {
    id: 1,
    folio: "03-2026",
    pdfAcuerdo: "03-2026.pdf", 
  },
  {
    id: 1,
    folio: "04-2026",
    pdfAcuerdo: "04-2026.pdf", 
  },
  {
    id: 1,
    folio: "05-2026",
    pdfAcuerdo: "05-2026.pdf", 
  },
];

export const dataConvocatorias = [
  /* {
   id: 1,
  nameFile: "Convocatoria-Licitacion-Publica-Nacional-ITE-01-2024",
   linkFile:
    "https://itetlax.org.mx/assets/pdf/convocatorias/Convocatoria-Licitacion-Publica-Nacional-ITE-01-2024.pdf",
  }, */
];

export const dataConvocatoriasApartado = [
  {
    id: 1,
    nameFile: "Convocatoria Licitacion ITE-LP-06-2024",
    linkFile:
      "https://itetlax.org.mx/assets/pdf/convocatorias/Convocatoria-ITE-LP-06-2024.pdf",
  },
];

export const dataInformes = [
  {
    mes: "Marzo",
    titulo:
      "INFORME DE LA SECRETARÍA EJECUTIVA RESPECTO DE LA RECEPCIÓN DE LOS LISTADOS Y EXPEDIENTES DIGITALES DE LAS PERSONAS CANDIDATAS DEL PROCESO ELECTORAL LOCAL EXTRAORDINARIO 2024-2025.",
    linkFile: "https://itetlax.org.mx/assets/pdf/informes/1.pdf",
  },

  {
    mes: "Marzo",
    titulo:
      "LISTADO DE MAGISTRADOS Y JUECES QUE VAN DIRECTO A LA BOLETA Y LAS PERSONAS CANDIDATAS QUE PASARON LA INSACULACIÓN” ENTREGADO POR EL CONGRESO DEL ESTADO DE TLAXCALA AL ITE DÍA 13 DE MARZO DE 2025.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Listado.pdf",
  },
  {
    mes: "Marzo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO REMITIDO POR EL CONGRESO DEL ESTADO DE TLAXCALA EL DÍA 18 DE MARZO DE 2025 AL ITE.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoActualizado.pdf",
  },
  {
    mes: "Marzo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO (21/MARZO/2025) DERIVADO DE SOLICITUD DE ACLARACIÓN REALIZADA AL CONGRESO DEL ESTADO POR EL ITE.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Listado21deMarzo.pdf",
  },
  {
    mes: "Abril",
    titulo:
      "ACTUALIZACIÓN DE LISTADO (10/ABRIL/2025) DERIVADO DE LAS SUSTITUCIONES REALIZADAS POR EL CONGRESO DEL ESTADO DE TLAXCALA.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoCuarto.pdf",
  },
  {
    mes: "Abril",
    titulo:
      "UBICA TU CASILLA",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Casilla.pdf",
  },
  {
    mes: "Abril",
    titulo:
      "ACTUALIZACIÓN DE LISTADO (15/ABRIL/2025) DERIVADO DE DIVERSAS ACTUACIONES",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/Listado1504.pdf",
  },
  {
    mes: "Abril",
    titulo:
      " ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (16/ABRIL/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoSeis.pdf",
  },


  {
    mes: "Abril",
    titulo:
     "INFORME CRONOLÓGICO CON CORTE AL 16 DE ABRIL DE 2025, QUE PRESENTA LA SECRETARIA EJECUTIVA  RESPECTO DE LAS ACTIVIDADES RELACIONADAS CON LA ENTREGA DE LOS LISTADOS REMITIDOS POR EL CONGRESO DEL ESTADO DE TLAXCALA.",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/INFORME_FINAL_CRONOLOGÍA.pdf",
  },


  {
    mes: "Abril",
    titulo:
      "LISTADO ACTUALIZADO DE CANDIDATURAS A MAGISTRATURAS DEL TRIBUNAL SUPERIOR DE JUSTICIA, MAGISTRATURAS DEL TRIBUNAL DE DISCIPLINA JUDICIAL, MAGISTRATURAS DEL TRIBUNAL DE JUSTICIA ADMINISTRATIVA, MAGISTRATURAS DEL TRIBUNAL DE CONCILIACIÓN Y ARBITRAJE, Y JUEZAS Y JUECES DEL PODER JUDICIAL LOCAL",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/ListadoActualizadoOrganizacion.pdf",
  },
   {
    mes: "Mayo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (17/MAYO/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/carousel/LISTADOSIETE.pdf",
  },
   {
    mes: "Mayo",
    titulo:
      "UBICACIÓN E INTEGRACIÓN DE MESAS DIRECTIVAS DE CASILLA (ENCARTE).",
    linkFile: "https://itetlax.org.mx/assets/pdf/ListadoCasillasAct.pdf",
  },
     {
    mes: "Mayo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (23/MAYO/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/Listado8.pdf",
  },
       {
    mes: "Mayo",
    titulo:
      "ACTUALIZACIÓN DE LISTADO DE CANDIDATURAS (31/MAYO/2025).",
    linkFile: "https://itetlax.org.mx/assets/pdf/Listado9.pdf",
  },
];
